// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useContext, useMemo} from 'react';
import cn from 'classnames';
import {useHistory} from 'react-router-dom';
import {i_card, i_cls_obj} from '../../../../hola/pub/ui/cards';
import {use_theme} from '../../../../hola/pub/settings_ctx';
import Chevron_right from '../../../../hola/pub/img/hola2023/icons/16/chevron_right.svg';
import {toolip_img_url} from '../../../../hola/pub/ui/toolip_img_url';
import {Menu_cards} from './menu_cards';
import {Button} from '../../../../hola/pub/lib/button';
import {App_context} from 'hola_app_context';
import {use_prices} from '../plans/use_prices';
import {use_translation_v} from '../../../../hola/pub/lib/trans_v';
import {use_menu_config} from './nav_utils';
import {use_screen} from '../../../../hola/pub/lib/screen_util';
import {use_debug_ui} from '../../../../hola/pub/lib/debug';

import styles from './nav_menu.module.less';

const Free_plan = ()=>{
    const {theme} = use_theme({def: 'toolip'});
    const {T} = use_translation_v({no_defaults: true});
    const history = useHistory();
    const on_banner_click = ()=>{ history.push('/dashboard'); };
    return <div className={styles.free_plan_banner}
      onClick={on_banner_click}>
      <img src={toolip_img_url('nav/gift.png')} className={styles.img}/>
      <div className={styles.text}>
        <p className={cn(theme.mono16, styles.title)}>
          <T>Free plan</T>
        </p>
        <p className={cn(theme.p14, styles.desc)}>Get a 3 day trial with
          <T>the product of your choice. No credit card required!</T></p>
      </div>
      <Button cls={styles.btn} caption={<>
        <span className={cn(theme.P, theme.p3, theme.med)}><T>Start free</T>
          </span>
        <Chevron_right/>
        </>}
        to="/dashboard" size="sm" round no_jump fit/>
    </div>;
};

export const Pricing_menu = ()=>{
    const {prices} = use_prices();
    const menu = use_menu_config();
    const {user} = useContext(App_context);
    const {theme} = use_theme({def: 'toolip'});
    const {T, t} = use_translation_v({no_defaults: true});
    const history = useHistory();
    const {width} = use_screen();
    const group_by_two = width < 1350;
    const debug_nav_menu_cards = use_debug_ui('updated_nav_menu_cards');
    const cards: i_card[] = useMemo(()=>{
        if (!menu?.pricing)
            return [];
        return menu.pricing.items.map(item=>{
            const product_price = prices[item.id];
            const price_from = product_price.ips_amount[0]
                ? <>${product_price.min_price_per_ip}/IP</>
                : <>${product_price.min_price_per_gb}/GB</>;
            return {
                id: item.id,
                title: item.title,
                to: undefined,
                on_click: ()=>{ history.push(item.to); },
                img: <img className={'lazyload'} alt={t(item.title)}
                  data-src={toolip_img_url(item.icon)}
                  style={{height: '40px'}}
                />,
                clickid: `nav_toolip_pricing_${item.id}`,
                text: group_by_two && debug_nav_menu_cards ? <>
                  <Button size="sm" round no_jump to={item.to}
                    fit cls={cn(styles.card_btn, theme.color_n800)}
                    caption={<>
                      <T>Start from</T> {price_from} <Chevron_right/>
                    </>}
                  />
                </> : <>
                  <p className={theme.p12}><T>{item.sub_title}</T></p>
                  <Button size="sm" round no_jump to={item.to}
                    fit cls={cn(styles.card_btn, theme.color_n800)}
                    caption={<>
                      <T>Start from</T> {price_from} <Chevron_right/>
                    </>}
                  />
                </>,
            };
        });
    }, [width]);
    const cls: i_cls_obj = {
        container: styles.cards,
        card: styles.card,
        title: cn(theme.monospace, styles.title, theme.p16),
        text: cn(theme.p3, theme.reg, styles.text),
        img: styles.flex_img,
    };
    return <Menu_cards cards={cards} cls={cls}
      group_by_two={group_by_two && debug_nav_menu_cards}>
      {!user && <Free_plan/>}
    </Menu_cards>;
};
